import { COLS, ROWS } from '../core/constants';
import { mulberry32 } from '../core/rng';
/** Тип клітинки. На v1 — лише 3, у наступних етапах додамо Bomb / Flame / Exit. */
export var Cell;
(function (Cell) {
    Cell[Cell["Floor"] = 0] = "Floor";
    Cell[Cell["SoftBlock"] = 1] = "SoftBlock";
    Cell[Cell["HardBlock"] = 2] = "HardBlock";
})(Cell || (Cell = {}));
export class Grid {
    cols;
    rows;
    cells;
    constructor(cols, rows) {
        this.cols = cols;
        this.rows = rows;
        this.cells = new Uint8Array(cols * rows);
    }
    /** За межами поля повертає HardBlock (умовна «стіна світу»). */
    get(c, r) {
        if (c < 0 || c >= this.cols || r < 0 || r >= this.rows)
            return Cell.HardBlock;
        return this.cells[r * this.cols + c];
    }
    set(c, r, v) {
        if (c < 0 || c >= this.cols || r < 0 || r >= this.rows)
            return;
        this.cells[r * this.cols + c] = v;
    }
}
/**
 * Генерує стандартний Bomberman-рівень:
 *  - тверда зовнішня рамка
 *  - шаховий патерн HardBlock усередині (парні координати)
 *  - SoftBlock з густиною `softDensity` поверх Floor
 *  - 3×3 безпечна зона у точці спавну (1,1)
 */
// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export function generateGrid(seed = 1, softDensity = 0.45) {
    const rand = mulberry32(seed);
    const g = new Grid(COLS, ROWS);
    for (let r = 0; r < ROWS; r++) {
        for (let c = 0; c < COLS; c++) {
            if (c === 0 || r === 0 || c === COLS - 1 || r === ROWS - 1)
                g.set(c, r, Cell.HardBlock);
            else if (c % 2 === 0 && r % 2 === 0)
                g.set(c, r, Cell.HardBlock);
            else
                g.set(c, r, Cell.Floor);
        }
    }
    const SAFE = new Set();
    for (let dr = 0; dr <= 2; dr++) {
        for (let dc = 0; dc <= 2; dc++) {
            SAFE.add(`${1 + dc},${1 + dr}`);
        }
    }
    for (let r = 1; r < ROWS - 1; r++) {
        for (let c = 1; c < COLS - 1; c++) {
            if (g.get(c, r) !== Cell.Floor)
                continue;
            if (SAFE.has(`${c},${r}`))
                continue;
            if (rand() < softDensity)
                g.set(c, r, Cell.SoftBlock);
        }
    }
    return g;
}
